/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/BuildingBean', 'model/KanbanBoard', 'model/LocationBean', 'model/SiteBean', 'model/StationBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./BuildingBean'), require('./KanbanBoard'), require('./LocationBean'), require('./SiteBean'), require('./StationBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildDevelopmentappspotcom) {
      root.BpmbuildDevelopmentappspotcom = {};
    }
    root.BpmbuildDevelopmentappspotcom.StationBean = factory(root.BpmbuildDevelopmentappspotcom.ApiClient, root.BpmbuildDevelopmentappspotcom.BuildingBean, root.BpmbuildDevelopmentappspotcom.KanbanBoard, root.BpmbuildDevelopmentappspotcom.LocationBean, root.BpmbuildDevelopmentappspotcom.SiteBean, root.BpmbuildDevelopmentappspotcom.StationBean);
  }
}(this, function(ApiClient, BuildingBean, KanbanBoard, LocationBean, SiteBean, StationBean) {
  'use strict';

  /**
   * The StationBean model module.
   * @module model/StationBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StationBean</code>.
   * @alias module:model/StationBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StationBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StationBean} obj Optional instance to populate.
   * @return {module:model/StationBean} The populated <code>StationBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('assetIdList'))
        obj.assetIdList = ApiClient.convertToType(data['assetIdList'], ['String']);
      if (data.hasOwnProperty('beanInstance'))
        obj.beanInstance = StationBean.constructFromObject(data['beanInstance']);
      if (data.hasOwnProperty('buildingBean'))
        obj.buildingBean = BuildingBean.constructFromObject(data['buildingBean']);
      if (data.hasOwnProperty('buildingId'))
        obj.buildingId = ApiClient.convertToType(data['buildingId'], 'String');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('kanbanBoard'))
        obj.kanbanBoard = KanbanBoard.constructFromObject(data['kanbanBoard']);
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('locationBean'))
        obj.locationBean = LocationBean.constructFromObject(data['locationBean']);
      if (data.hasOwnProperty('locationId'))
        obj.locationId = ApiClient.convertToType(data['locationId'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('operatingStatus'))
        obj.operatingStatus = ApiClient.convertToType(data['operatingStatus'], 'String');
      if (data.hasOwnProperty('postTaskIdList'))
        obj.postTaskIdList = ApiClient.convertToType(data['postTaskIdList'], ['String']);
      if (data.hasOwnProperty('preTaskIdList'))
        obj.preTaskIdList = ApiClient.convertToType(data['preTaskIdList'], ['String']);
      if (data.hasOwnProperty('qualityId'))
        obj.qualityId = ApiClient.convertToType(data['qualityId'], 'String');
      if (data.hasOwnProperty('requiresQualityCheck'))
        obj.requiresQualityCheck = ApiClient.convertToType(data['requiresQualityCheck'], 'Boolean');
      if (data.hasOwnProperty('siteBean'))
        obj.siteBean = SiteBean.constructFromObject(data['siteBean']);
      if (data.hasOwnProperty('siteId'))
        obj.siteId = ApiClient.convertToType(data['siteId'], 'String');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
    }
    return obj;
  }

  /**
   * @member {Array.<String>} assetIdList
   */
  exports.prototype.assetIdList = undefined;

  /**
   * @member {module:model/StationBean} beanInstance
   */
  exports.prototype.beanInstance = undefined;

  /**
   * @member {module:model/BuildingBean} buildingBean
   */
  exports.prototype.buildingBean = undefined;

  /**
   * @member {String} buildingId
   */
  exports.prototype.buildingId = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {String} description
   */
  exports.prototype.description = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {module:model/KanbanBoard} kanbanBoard
   */
  exports.prototype.kanbanBoard = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {module:model/LocationBean} locationBean
   */
  exports.prototype.locationBean = undefined;

  /**
   * @member {String} locationId
   */
  exports.prototype.locationId = undefined;

  /**
   * @member {String} name
   */
  exports.prototype.name = undefined;

  /**
   * @member {String} operatingStatus
   */
  exports.prototype.operatingStatus = undefined;

  /**
   * @member {Array.<String>} postTaskIdList
   */
  exports.prototype.postTaskIdList = undefined;

  /**
   * @member {Array.<String>} preTaskIdList
   */
  exports.prototype.preTaskIdList = undefined;

  /**
   * @member {String} qualityId
   */
  exports.prototype.qualityId = undefined;

  /**
   * @member {Boolean} requiresQualityCheck
   */
  exports.prototype.requiresQualityCheck = undefined;

  /**
   * @member {module:model/SiteBean} siteBean
   */
  exports.prototype.siteBean = undefined;

  /**
   * @member {String} siteId
   */
  exports.prototype.siteId = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/StationBean.js